import {
  type FormattedPriceSettings,
  type PurchaseInfo,
} from '@setplex/tria-api'
import { aye } from '~/shared/helpers'

export type SseLoadedInfo = {
  purchaseInfo?: PurchaseInfo
}
export type SsePurchaseInfo = SseLoadedInfo['purchaseInfo']
export type SseItemId = { itemId: number }
export type SseValue = SsePurchaseInfo | SseItemId
export type SseIds = Map<number, SseValue>

export const isSseItemId = (
  value: SsePurchaseInfo | SseItemId
): value is SseItemId => {
  return aye(value) && 'itemId' in value
}

export type Purchased = {
  channel: SseIds
  channelSet: SseIds
  episode: SseIds
  liveEvent: SseIds
  partnerProduct: SseIds
  season: SseIds
  subscription: SseIds
  tvShow: SseIds
  tvShowSet: SseIds
  vod: SseIds
  vodSet: SseIds
}

export type Purchaseable = {
  id?: number
  priceSettings?: FormattedPriceSettings[]
  tvShowPriceSettings?: FormattedPriceSettings[]
  seasonPriceSettings?: FormattedPriceSettings[]
  episodePriceSettings?: FormattedPriceSettings[]
  purchaseInfo?: PurchaseInfo
}

export type AdjustPurchaseableFn = <T extends Purchaseable | undefined>(
  item: T
) => T

export type AdjustPurchaseableFnFactory = (
  type: keyof Purchased,
  bundle?: keyof Purchased
) => AdjustPurchaseableFn
